export type CatalogSortColumn =
  | 'title'
  | 'artist'
  | 'release'
  | 'release_year'
  | 'create_date'
  | 'include_date'
  | 'status'
  | 'bpm'
  | 'rating'
  | 'explicitness'
  | 'gain'
  | 'isrc'
  | 'duration'
  | null;

export const VALID_SORT_COLUMNS: CatalogSortColumn[] = [
  'title',
  'artist',
  'release',
  'release_year',
  'create_date',
  'include_date',
  'status',
  'bpm',
  'rating',
  'explicitness',
  'gain',
  'isrc',
  'duration',
];
